import {customMarkerTemplateIcon} from "../templates/CustomMarkerTemplate/CustomMarkerTemplateIcon";
import {customMarkerTemplateCard} from "../templates/CustomMarkerTemplate/CustomMarkerTemplateCard";

/**
 * Custom marker class
 */
export class CustomMarker {
    /**
     * @param latLng {LatLng}
     * @param attributes {PropertyAppResource}
     */
    constructor(latLng, attributes) {
        this._latLng = latLng;
        this._attributes = attributes;
        this._htmlElem = '';
    }

    /**
     * @returns {LatLng}
     */
    get latLng() {
        return this._latLng;
    }

    /**
     * @returns {PropertyAppResource}
     */
    get attributes() {
        return this._attributes;
    }

    /**
     * @returns {string}
     */
    get htmlElem() {
        return this._htmlElem;
    }

    /**
     * @param htmlElem {string}
     */
    set htmlElem(htmlElem) {
        this._htmlElem = htmlElem;
    }

    /**
     * function that returns the template for the custom marker icon
     * @returns {string}
     */
    templateIcon() {
        return customMarkerTemplateIcon(this);
    }

    /**
     * function that returns the template for the custom marker card
     * @returns {string}
     */
    templateCard() {
        return customMarkerTemplateCard(this);
    }

    /**
     * @returns {string}
     */
    getActiveIconClass() {
        return 'custom-marker-icon-active';
    }

    /**
     * @returns {string}
     */
    getActiveCaretClass() {
        return 'marker-caret-active';
    }
}
